<div class="order-form-popup d-flex justify-content-between">
  <app-recent-order [recentOrder]="order" [stepNo]="stepNo"></app-recent-order>
  <span mat-dialog-close class="close mt-1 mr-1">
    <mat-icon class="icon-cross"></mat-icon>
  </span>
</div>
<h2 mat-dialog-title class="text-tertiary uppercase pt-0">
  <span>{{multilingualService?.langMap?.TITLE_MAIL_ORDER_DETAILS}}</span>
</h2>
<mat-dialog-content class="mat-typography">
  <div class="view-detail">
    <div class="list-view d-flex mt-3">
      <div class="custom-block-width">
        <h5 class="text-tertiary title-10 text-w-500">General</h5>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService?.langMap?.TITLE_HOME_ORDER_NUMBER}}</label>
            <p>{{ order.orderNumber }}</p>
          </div>
        </div>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService?.langMap?.LABEL_CLAIM_DETAILS_RX_NUMBER}}</label>
            <p>{{order.prescriptionFills?.rxNumber}}</p>
          </div>
        </div>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService?.langMap?.LABEL_CLAIM_DETAILS_DRUG_NAME}}</label>
            <p>{{order.prescriptionFills?.prescribedDrugName}}</p>
          </div>
        </div>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService?.langMap?.LABEL_CLAIM_DETAILS_DAYS_SUPPLY}}</label>
            <p>{{order.prescriptionFills?.daysSupply || '-'}}</p>
          </div>
        </div>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService?.langMap?.LABEL_MAIL_ORDER_DETAILS_ORDER_STATUS}}</label>
            <p>{{order.orderStatus}}</p>
          </div>
        </div>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService?.langMap?.LABEL_MAIL_ORDER_DETAILS_RECEIVED_DATE}}</label>
            <p>{{order.receivedDate | date: 'MM-dd-yyyy'}}</p>
          </div>
        </div>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService?.langMap?.LABEL_CLAIM_DETAILS_PHARMACY_NAME}}</label>
            <p>{{order.pharmacy}}</p>
          </div>
        </div>

      </div>
      <div class="custom-block-width margin-auto">
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService?.langMap?.LABEL_MAIL_ORDER_DETAILS_PATIENT_NAME}}</label>
            <p>{{order.prescriptionFills?.patientFirstName}} {{order.prescriptionFills?.patientLastName}}</p>
          </div>
        </div>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService?.langMap?.LABEL_PRESCRIPTION_DETAILS_PATIENT_DOB}}</label>
            <p>{{order.prescriptionFills?.patientDateOfBirth | date: 'MM-dd-yyyy'}}</p>
          </div>
        </div>
        <h5 class="text-tertiary title-10 text-w-500">{{multilingualService?.langMap?.TITLE_CART_SUMMARY_SHIPPING_ADDRESS}}</h5>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService?.langMap?.LABEL_SHIP_TO_NAME}}</label>
            <p>{{order.shipToAddress?.shipToName || '-'}}</p>
          </div>
        </div>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService?.langMap?.LABEL_CART_ADDRESS_CARE_OF_NAME}}</label>
            <p>{{order.shipToAddress?.careOfName || '-'}}</p>
          </div>
        </div>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService?.langMap?.LABEL_ADD_NEW_ADDRESS_ADDRESS_LINE_1}}</label>
            <p>{{order.shipToAddress?.addressLine1}}</p>
          </div>
        </div>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService?.langMap?.LABEL_ADD_NEW_ADDRESS_ADDRESS_LINE_2}}</label>
            <p>{{order.shipToAddress?.addressLine2 || '-'}}</p>
          </div>
        </div>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService?.langMap?.LABEL_ADD_NEW_ADDRESS_CITY}}</label>
            <p>{{order.shipToAddress?.city}}</p>
          </div>
        </div>

      </div>
      <div class="custom-block-width">
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService?.langMap?.LABEL_FIND_PHARMACY_STATE}}</label>
            <p>{{order.shipToAddress?.state}}</p>
          </div>
        </div>

        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService?.langMap?.LABEL_ADD_NEW_ADDRESS_ZIPCODE}}</label>
            <p>{{order.shipToAddress?.zipCode}}</p>
          </div>
        </div>
        <h5 class="text-tertiary title-10 text-w-500">{{multilingualService?.langMap?.LABEL_MAIL_ORDER_DETAILS_ORDER_STATUS}}</h5>
        <div class="form-group">
          <p>{{order.orderStatus}}</p>
        </div>
        <ng-container *ngIf="showShipmentDetails()">
          <h5 class="text-tertiary title-10 text-w-500 mt-4">{{multilingualService?.langMap?.TITLE_MAIL_ORDER_DETAILS_ORDER_TRACKING}}</h5>
          <div *ngIf="order.shipmentDate" class="information-block">
            <div class="form-group">
              <label>{{multilingualService?.langMap?.LABEL_MAIL_ORDER_DETAILS_SHIPMENT_DATE}}</label>
              <p>{{order.shipmentDate | date: 'MM-dd-yyyy'}}</p>
            </div>
          </div>
          <div *ngIf="order.shipmentCarrier" class="information-block">
            <div class="form-group">
              <label>{{multilingualService?.langMap?.LABEL_MAIL_ORDER_DETAILS_SHIPMENT_CARRIER}}</label>
              <p>{{order.shipmentCarrier}}</p>
            </div>
          </div>
          <div *ngIf="order.shipmentMethod" class="information-block">
            <div class="form-group">
              <label>{{multilingualService?.langMap?.LABEL_MAIL_ORDER_DETAILS_SHIPMENT_METHOD}}</label>
              <p>{{order.shipmentMethod}}</p>
            </div>
          </div>
          <div *ngIf="order.shipmentTrackingNumber" class="information-block">
            <div class="form-group">
              <label>{{multilingualService?.langMap?.LABEL_MAIL_ORDER_DETAILS_SHIPMENT_NUMBER}}</label>
              <p>{{order.shipmentTrackingNumber}}</p>
            </div>
          </div>
        </ng-container>

      </div>
    </div>
  </div>
</mat-dialog-content>
